export default __webpack_public_path__ + "static/broderie3.inspirations-5a7189a0b0ecd52430b304a186d6382e.jpg";